import React from 'react';
import { Button, Paper, Typography } from '@material-ui/core';

export default class RouteBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (!this.state.failed) return this.props.children;
    return <main style={{ maxWidth: 520, margin: '48px auto', padding: 20 }}><Paper style={{ padding: 28 }}>
      <Typography component="h1" variant="h5">This page couldn’t load</Typography>
      <Typography role="alert" style={{ margin: '20px 0' }}>Please check your connection and reload the page.</Typography>
      <Button variant="contained" color="primary" onClick={() => window.location.reload()}>Reload page</Button>
      <Button href="/">Back to Options</Button>
    </Paper></main>;
  }
}
